const BASE_URL = process.env.REACT_APP_FASTAPI_URL;

function getDateRange(period) {
  const now = new Date();
  const end = now.toISOString();
  const start = new Date(now);
  if (period === 'Today') start.setHours(0, 0, 0, 0);
  else if (period === '7 days') start.setDate(now.getDate() - 7);
  else if (period === '30 days') start.setDate(now.getDate() - 30);
  else if (period === '90 days') start.setDate(now.getDate() - 90);
  return { startDate: start.toISOString(), endDate: end };
}

async function fetchMetrics(endpoint, period) {
  const { startDate, endDate } = getDateRange(period);
  const params = new URLSearchParams({ startDate, endDate });
  const res = await fetch(`${BASE_URL}/admin/metrics/${endpoint}?${params}`);
  if (!res.ok) throw new Error(`Failed to fetch ${endpoint} metrics`);
  return res.json();
}

export const getBusinessMetrics = (period) => fetchMetrics('business', period);
export const getUserMetrics     = (period) => fetchMetrics('users', period);
export const getValetMetrics    = (period) => fetchMetrics('valets', period);
export const getValets          = () => fetch(`${BASE_URL}/admin/valets`).then(r => { if (!r.ok) throw new Error(`Valets endpoint returned ${r.status}`); return r.json(); });

export const deactivateValet = (id) => {
  return fetch(`${BASE_URL}/admin/valets/deactivate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ valetId: id }),
  }).then(r => { if (!r.ok) throw new Error(`Deactivate failed (${r.status})`); return r.json(); });
};

export const reactivateValet = (id) => {
  return fetch(`${BASE_URL}/admin/valets/reactivate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ valetId: id }),
  }).then(r => { if (!r.ok) throw new Error(`Reactivate failed (${r.status})`); return r.json(); });
};
